import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { longDateString, getPageSizes } from "../../utils";
import classNames from "classnames";
import {
    getCycle,
    saveCycle,
    deleteCycle,
} from "../../services/RepositoryService";
import Paper from "@mui/material/Paper";
import {
    Grid,
    Table,
    TableHeaderRow,
    TableFilterRow,
    PagingPanel,
    TableColumnResizing,
    Toolbar,
    TableSelection,
    TableColumnVisibility,
    ColumnChooser,
} from "@devexpress/dx-react-grid-material-ui";

import {
    SelectionState,
    FilteringState,
    IntegratedFiltering,
    SortingState,
    PagingState,
    IntegratedPaging,
    IntegratedSelection,
    IntegratedSorting,
} from "@devexpress/dx-react-grid";
import StarekContext from "../../context/StarekContext";
import Spinner from "../../components/Spinner";
import { confirm } from "../../components/Confirmation";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const Cycle = (props) => {
    const context = useContext(StarekContext);
    const navigator = useNavigate();

    const { id } = useParams();
    const [item, setItem] = useState({});
    const [cycleId, setCycleId] = useState(id == null ? 0 : id);

    const [loadingPrimary, setLoadingPrimary] = useState(true);
    const [showError, setShowError] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");

    const [columns, setColumns] = useState([
        { name: "type", title: "Processing" },
        { name: "name", title: "Name" },
        {
            name: "description",
            title: "Description",
        },
    ]);
    const [defaultColumnWidths] = useState([
        { columnName: "type", width: 300 },
        { columnName: "name", width: 300 },
        { columnName: "description", width: 300 },
    ]);

    const [defaultHiddenColumnNames] = useState([]);
    const [tableColumnExtensions] = useState([{ columnName: "description" }]);
    const [showFilter] = useState(false);

    const CycleStageTableCell = (props) => {
        if (props.column.name === "type") {
            return (
                <Table.Cell {...props}>
                    <i
                        className={classNames("fa fa-circle", {
                            "text-success": props.row.type === 1,
                            "text-danger": props.row.type !== 1,
                        })}
                    ></i>{" "}
                </Table.Cell>
            );
        }
        if (props.column.name === "name") {
            return (
                <Table.Cell {...props}>
                    {props.row.stage ? props.row.stage.name : ""}
                </Table.Cell>
            );
        }
        return <Table.Cell {...props} />;
    };

    useEffect(() => {
        if (id == null || id <= 0) {
            setLoadingPrimary(false);
            return;
        }
        const includes = ["stages", "created_by", "updated_by"];
        (async () => {
            try {
                const cycle = await getCycle(
                    context.activePlant.id,
                    cycleId,
                    includes
                );
                if (!cycle) {
                    throw new Error("something went wrong!");
                }
                setItem(cycle);
            } catch (e) {
                setMessage(e);
                setShowMessage(true);
            } finally {
                setLoadingPrimary(false);
            }
        })();
    }, [id]);

    const remove = async () => {
        if (
            (await confirm(`Are you sure you want to delete this cycle?`)) ==
            true
        ) {
            try {
                const response = await deleteCycle(
                    context.activePlant.id,
                    item.id
                );
                if (!response) {
                    throw new Error("something went wrong!");
                }
                if (!response.result) {
                    throw new Error(response.message);
                }
                navigator(`/cycles`);
            } catch (e) {
                setMessage(e);
                setShowMessage(true);
            } finally {
            }
        }
    };

    const save = async () => {
        if (item.name == null || item.name.length == 0) {
            console.log("aaa");
            setShowError(true);
            setMessage("Please enter name.");
            setShowMessage(true);
            return false;
        }
        let cycle = await saveCycle(context.activePlant.id, item);
        setCycleId(cycle.id);
    };

    return loadingPrimary ? (
        <>
            <Spinner />
            <div className="text-xs d-flex justify-content-center">
                <i className="fa fa-microchip fa-10x text-success"></i>
            </div>
        </>
    ) : (
        <>
            <div className="d-flex justify-content-center">
                {showMessage && (
                    <div
                        className={
                            showError
                                ? "d-flex form-group alert alert-danger"
                                : "d-flex form-group alert alert-success"
                        }
                    >
                        <div className="d-inline-block col-11 inline-block">
                            {message}
                        </div>
                        <div className="d-inline-block col-1 inline-block text-right">
                            <i
                                className="fa fa-times"
                                onClick={() => {
                                    setMessage("");
                                    setShowMessage(false);
                                    setShowError(false);
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
            {id > 0 && (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-6">
                            <div class="card card-primary">
                                <div class="card-header">
                                    <h3 class="card-title">{item?.name}</h3>
                                    <span className="text-sm float-right">
                                        Updated{" "}
                                        {longDateString(item?.updated_at)} by{" "}
                                        {item?.updated_by?.name}
                                    </span>
                                </div>
                                <div class="card-body">
                                    <div className="form-group">
                                        <label htmlFor="cycle.name">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="cycle.name"
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    name: e.target.value,
                                                });
                                            }}
                                            value={item.name ? item.name : ""}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                            className="form-control"
                                            rows="2"
                                            id="cycle.description"
                                            value={
                                                item.description
                                                    ? item.description
                                                    : ""
                                            }
                                            onChange={(e) => {
                                                setItem({
                                                    ...item,
                                                    description: e.target.value,
                                                });
                                            }}
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="card-footer">
                                    <button
                                        className="btn btn-info btn-danger text-left"
                                        onClick={async () => {
                                            await remove();
                                        }}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        type="submit"
                                        class="btn btn-primary ml-2 float-right"
                                        onClick={async () => {
                                            await save();
                                        }}
                                    >
                                        Save
                                    </button>
                                    <button
                                        className="btn btn-primary ml-2 float-right"
                                        onClick={async () => {
                                            navigator(`/cycles`);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div class="card card-secondary">
                                <div class="card-header">
                                    <h3 class="card-title">Cycle Snapshot</h3>

                                    <small className="float-right">
                                        <i className="fa fa-info-circle"></i>{" "}
                                        View Processing and Idle Times for{" "}
                                        {item?.name}
                                    </small>
                                </div>
                                <div class="card-body">
                                    <div
                                        style={{
                                            height: "20vh",
                                            position: "relative",
                                            marginBottom: "1%",
                                            padding: "1%",
                                        }}
                                    >
                                        <Pie
                                            options={{
                                                maintainAspectRatio: false,
                                            }}
                                            data={{
                                                labels: [
                                                    "Processing",
                                                    "Idle",
                                                    "Other",
                                                ],
                                                datasets: [
                                                    {
                                                        label: "# of Votes",
                                                        data: [12, 19, 69],
                                                        backgroundColor: [
                                                            "rgba(255, 99, 132, 0.2)",
                                                            "rgba(54, 162, 235, 0.2)",
                                                            "rgba(255, 206, 86, 0.2)",
                                                        ],
                                                        borderColor: [
                                                            "rgba(255, 99, 132, 1)",
                                                            "rgba(54, 162, 235, 1)",
                                                            "rgba(255, 206, 86, 1)",
                                                        ],
                                                        borderWidth: 1,
                                                    },
                                                ],
                                            }}
                                        />
                                    </div>
                                </div>

                                <div class="card-footer"></div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div class="card card-info">
                                <div class="card-header">
                                    <h3 class="card-title">
                                        Cycle Stages for {item?.name}
                                    </h3>
                                    <span className="text-sm float-right">
                                        Define Cycle Stages for {item?.name}
                                    </span>
                                </div>
                                <div class="card-body">
                                    <Paper>
                                        <Grid
                                            rows={item.stages}
                                            columns={columns}
                                            getRowId={(row) => row.id}
                                        >
                                            {showFilter && <FilteringState />}
                                            <SortingState />
                                            <SelectionState />
                                            <PagingState
                                                defaultCurrentPage={0}
                                                defaultPageSize={
                                                    getPageSizes()[1]
                                                }
                                            />

                                            {showFilter && (
                                                <IntegratedFiltering />
                                            )}

                                            <IntegratedSorting />
                                            <IntegratedSelection />
                                            <IntegratedPaging />

                                            <Table
                                                columnExtensions={
                                                    tableColumnExtensions
                                                }
                                                cellComponent={
                                                    CycleStageTableCell
                                                }
                                            />
                                            <TableColumnVisibility
                                                defaultHiddenColumnNames={
                                                    defaultHiddenColumnNames
                                                }
                                            />
                                            <TableColumnResizing
                                                defaultColumnWidths={
                                                    defaultColumnWidths
                                                }
                                            />
                                            <TableHeaderRow
                                                showSortingControls
                                            />
                                            {showFilter && <TableFilterRow />}
                                            <TableSelection
                                                showSelectionColumn={false}
                                                selectByRowClick
                                                highlightRow
                                            />
                                            <Toolbar />
                                            <ColumnChooser />
                                            <PagingPanel
                                                pageSizes={getPageSizes()}
                                            />
                                        </Grid>
                                    </Paper>
                                </div>

                                <div class="card-footer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export { Cycle };
